// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import LandingPage from './pages/LandingPage';
import IntakeForm from './pages/IntakeForm';
import Checkout from './pages/Checkout';
import Generating from './pages/Generating';
import ReportDelivery from './pages/ReportDelivery';
import AppraiserDirectory from './pages/AppraiserDirectory';
import AppraiserSignup from './pages/AppraiserSignup';
import Blog from './pages/Blog';
import ArticlePage from './pages/ArticlePage';
import Terms, { RefundPolicy, Privacy, NotFound } from './pages/Terms';
import AgentLogin from './pages/AgentLogin';
import AgentRoute from './components/agent/AgentRoute';
import PendingApproval from './pages/agent/PendingApproval';
import Dashboard from './pages/agent/Dashboard';
import Leads from './pages/agent/Leads';
import LeadDetail from './pages/agent/LeadDetail';
import Buyers from './pages/agent/Buyers';
import Contracts from './pages/agent/Contracts';
import ContractPreview from './pages/agent/ContractPreview';
import SignContract from './pages/sign/SignContract';
import Messages from './pages/agent/Messages';
import AgentSettings from './pages/agent/Settings';
import SubmitLead from './pages/agent/SubmitLead';
import MySubmissions from './pages/agent/MySubmissions';
import SubmissionDetail from './pages/agent/SubmissionDetail';
import KnowledgeBase from './pages/agent/KnowledgeBase';
import Finances from './pages/agent/Finances';
import LeadIntake from './pages/LeadIntake';
import Inbox from './pages/agent/Inbox';
import Training from './pages/agent/Training';
import Reports from './pages/agent/Reports';
import JvStatus from './pages/JvStatus';
import JvDashboard from './pages/agent/JvDashboard';
import Footer from './components/Footer';

const paypalOptions = {
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: 'USD',
  intent: 'capture'
};

export default function App() {
  return (
    <PayPalScriptProvider options={paypalOptions}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/start" element={<IntakeForm />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/generating/:orderId" element={<Generating />} />
          <Route path="/report/:reportId" element={<ReportDelivery />} />
          <Route path="/appraisers" element={<AppraiserDirectory />} />
          <Route path="/appraisers/join" element={<AppraiserSignup />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/lead-intake" element={<LeadIntake />} />
          <Route path="/lead-intake/:slug" element={<LeadIntake />} />
          <Route path="/agent/login" element={<AgentLogin />} />
          <Route path="/jv-status/:tokenId" element={<JvStatus />} />
          <Route path="/agent/pending" element={<PendingApproval />} />
          <Route path="/agent/dashboard" element={<AgentRoute roles={['admin','agent']}><Dashboard /></AgentRoute>} />
          <Route path="/agent/leads" element={<AgentRoute roles={['admin','agent']}><Leads /></AgentRoute>} />
          <Route path="/agent/leads/:leadId" element={<AgentRoute roles={['admin','agent']}><LeadDetail /></AgentRoute>} />
          <Route path="/agent/buyers" element={<AgentRoute roles={['admin','agent']}><Buyers /></AgentRoute>} />
          <Route path="/agent/contracts" element={<AgentRoute roles={['admin','agent']}><Contracts /></AgentRoute>} />
          <Route path="/agent/contracts/preview/:type" element={<AgentRoute roles={['admin','agent']}><ContractPreview /></AgentRoute>} />
          <Route path="/agent/contracts/preview" element={<AgentRoute roles={['admin','agent']}><ContractPreview /></AgentRoute>} />
          <Route path="/agent/finances" element={<AgentRoute roles={['admin','agent']}><Finances /></AgentRoute>} />
          <Route path="/agent/messages" element={<AgentRoute roles={['admin','agent']}><Messages /></AgentRoute>} />
          <Route path="/agent/inbox" element={<AgentRoute roles={['admin','agent']}><Inbox /></AgentRoute>} />
          <Route path="/agent/reports" element={<AgentRoute roles={['admin','agent']}><Reports /></AgentRoute>} />
          <Route path="/agent/jv-dashboard" element={<AgentRoute roles={['admin','agent']}><JvDashboard /></AgentRoute>} />
          <Route path="/agent/settings" element={<AgentRoute roles={['admin','agent']}><AgentSettings /></AgentRoute>} />
          <Route path="/agent/submit" element={<AgentRoute roles={['admin','agent','lead_submitter']}><SubmitLead /></AgentRoute>} />
          <Route path="/agent/submissions" element={<AgentRoute roles={['admin','agent','lead_submitter']}><MySubmissions /></AgentRoute>} />
          <Route path="/agent/submissions/:leadId" element={<AgentRoute roles={['admin','agent','lead_submitter']}><SubmissionDetail /></AgentRoute>} />
          <Route path="/agent/knowledge" element={<AgentRoute roles={['admin','agent','lead_submitter']}><KnowledgeBase /></AgentRoute>} />
          <Route path="/agent/training" element={<AgentRoute roles={['admin','agent','lead_submitter']}><Training /></AgentRoute>} />
          <Route path="/sign/:token" element={<SignContract />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ConditionalFooter />
      </Router>
    </PayPalScriptProvider>
  );
}

function ConditionalFooter() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/agent') || pathname.startsWith('/sign')) return null;
  return <Footer />;
}
